export default "__VITE_ASSET__Hic07yjL__"